import React, { useState, useEffect } from "react";
import CollapseButton from "../../../utilities/CollapseButton/CollapseButton";
import {
  transactionType,
  actionDescription,
} from "../../Page/TransactionSummaryPage/Shared/Constants";
import {
  checkSectionValid,
  setStatusStyle,
} from "../../Page/TransactionSummaryPage/Shared/HelperFunctions";
import { generalSubscriber } from "../../Page/TransactionSummaryPage/Shared/Constants";

const DiscountsAndBenefits = ({
  data,
  context,
  programDiscounts,
  dealType,
  currentSubscriber,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [allDiscounts, setDiscounts] = useState(<div />);
  const [showComponent, setShowComponent] = useState(
    checkSectionValid(programDiscounts),
  );
  const cardTitle =
    data.discountsAndBenefitsTopic.value === ""
      ? "הנחות והטבות"
      : data.discountsAndBenefitsTopic.value;

  useEffect(() => {
    if (showComponent || currentSubscriber !== undefined) {
      if (currentSubscriber === undefined) {
        setDiscounts(setDetails(programDiscounts.discounts, dealType));
      } else {
        var programDiscountsBySubscriber = programDiscounts?.discounts?.filter(
          (discount) => discount.subscriber === currentSubscriber,
        );
        setShowComponent(true);
        setDiscounts(setDetails(programDiscountsBySubscriber, dealType));
        if (
          !programDiscountsBySubscriber ||
          programDiscountsBySubscriber?.length === 0
        ) {
          setShowComponent(false);
        }
      }
    }
  }, [programDiscounts, currentSubscriber]);

  return showComponent ? (
    <div className="block-frame p-2">
      <CollapseButton
        cardTitle={cardTitle}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
      />
      {isOpen && (
        <div className="block-frame__container">
          <hr />
          {allDiscounts}
        </div>
      )}
    </div>
  ) : null;
};

function setDetails(discounts, dealType) {
  const isDealTypeChangeOrReplace =
    dealType === transactionType.Replace || dealType === transactionType.Change;

  let res = discounts?.map((discount, idx) => {
    const isCancelled =
      discount.action.toLowerCase() === "remove" ||
      discount.action.toLowerCase() === "disconnect";
    const isExists = discount.action.toLowerCase() === "exists";

    return (
      <div
        className="block-frame__list-info"
        key={idx.toString() + discount.description}
      >
        <div className="block-frame__row block-frame__row--1">
          <div className="block-frame__status-holder">
            {isDealTypeChangeOrReplace && (
              <p
                className={
                  "block-frame__status block-frame__status" +
                  setStatusStyle(discount.action)
                }
              >
                {actionDescription[discount.action]}
              </p>
            )}
            <label
              className={isCancelled ? "cancelled" : isExists ? "isExists" : ""}
            >
              {discount.description}
            </label>
          </div>
        </div>
      </div>
    );
  });

  /*
    if(res.length > 1) {
        res = <ul>
                {res.map((discount, idx) => {
                    return <li key={idx.toString() + discount.description}>
                                {discount}
                            </li>})}
              </ul>
    } */

  return res;
}

export default DiscountsAndBenefits;
